import { DPR } from '@constants/common.const';
import Phaser from 'phaser';

/**
 * Shadow Nine-Slice Game Object
 *
 * A reusable nine-slice shadow that can be scaled to fit different panel sizes.
 * Based on shadow-9slice-16radius.png (256x256, 176x176 hole, 16px radius, 40px padding)
 */
type ShadowType = 'sharp' | 'rounded'; // radius 16px | 20px
const sliceSize = 40 * DPR;

export class ShadowNineSlice extends Phaser.GameObjects.NineSlice {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    width: number,
    height: number,
    type: ShadowType = 'sharp',
    alpha: number = 0.25,
  ) {
    const texture =
      type === 'sharp' ? 'shadow-9slice-16radius' : 'shadow-9slice-20radius';
    // Calculate the slice values based on your image specs:
    // Art padding is 40px on each side
    // The center hole is 176x176, so the shadow area is (256-176)/2 = 40px on each side
    super(
      scene,
      x,
      y,
      texture,
      undefined, // frame
      width + sliceSize,
      height + sliceSize,
      sliceSize, // leftWidth
      sliceSize, // rightWidth
      sliceSize, // topHeight
      sliceSize, // bottomHeight
    );

    this.setAlpha(alpha);
    scene.add.existing(this);
  }

  /**
   * Update the shadow size to match a panel
   * @param width New width
   * @param height New height
   */
  resize(width: number, height: number): this {
    this.setSize(width + sliceSize, height + sliceSize);
    return this;
  }
}
